var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex mb-6 gap-2" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v(" mdi-alphabetical-variant "),
          ]),
          _c("span", { staticClass: "text-xl font-medium text-primary" }, [
            _vm._v("ภาษา"),
          ]),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "p-5", attrs: { flat: "" } },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-6" },
            [
              _c("v-icon", [_vm._v(" mdi-alphabetical-variant ")]),
              _c("span", { staticClass: "text-xl font-medium" }, [
                _vm._v(" " + _vm._s(_vm.$t("language.language.title"))),
              ]),
            ],
            1
          ),
          _c("language-selection", {
            attrs: {
              text: _vm.$t("language.language.uiLanguage"),
              items: _vm.ui,
              state: _vm.state.uiLanguage,
            },
            on: {
              input: function ($event) {
                return _vm.submit("uiLanguage")
              },
            },
            model: {
              value: _vm.setting.uiLanguage,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "uiLanguage", $$v)
              },
              expression: "setting.uiLanguage",
            },
          }),
          _c("language-selection", {
            attrs: {
              text: _vm.$t("language.language.docLanguage"),
              items: _vm.doc,
              state: _vm.state.docLanguage,
            },
            on: {
              input: function ($event) {
                return _vm.submit("docLanguage")
              },
            },
            model: {
              value: _vm.setting.docLanguage,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "docLanguage", $$v)
              },
              expression: "setting.docLanguage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }